import React from 'react';
import { SectionReveal } from './ui/SectionReveal';
import { Rocket, Megaphone, Users, DollarSign, Award } from 'lucide-react';
export function Services() {
  const services = [{
    icon: <Users className="w-6 h-6 text-accent" data-id="element-244" />,
    title: 'Engineering Leadership',
    tagline: 'Operational excellence.',
    description: "Drawing on 10+ years building Waydev across 500+ engineering orgs, I partner with CTOs and VPEs to turn engineering into the company's sharpest competitive edge.",
    outcomes: ['Implement DORA metrics effectively', 'Scale from 20 → 100+ engineers structurally', 'Design robust engineering ladders', 'Org diagnostics & 90-day remediation plans'],
    featured: true
  }, {
    icon: <Award className="w-6 h-6 text-accent" data-id="element-245" />,
    title: 'Gartner & G2 Leader Strategy',
    tagline: 'Market positioning.',
    description: 'I led Waydev to recognition in the 2026 Gartner® Magic Quadrant™ for Developer Productivity Insight Platforms. I advise B2B SaaS leadership on navigating analyst relations to turn Gartner mentions and G2 badges into enterprise pipeline.',
    outcomes: ['Analyst relations playbook (Gartner, Forrester, IDC)', 'Magic Quadrant & Hype Cycle positioning', 'G2 Leader & High Performer badge strategy', 'Executive briefing decks that resonate'],
    featured: true
  }, {
    icon: <DollarSign className="w-6 h-6 text-accent" data-id="element-246" />,
    title: 'Fundraising Strategy',
    tagline: 'Capital execution.',
    description: 'Having raised multiple rounds for Waydev, I advise founders on building investor momentum, running a tight process, and closing rounds on favorable terms.',
    outcomes: ['Investor target list & warm intro strategy', 'Data room optimization', 'Term sheet negotiation prep', 'Process and timing management'],
    featured: false
  }, {
    icon: <Rocket className="w-6 h-6 text-accent" data-id="element-247" />,
    title: 'Product Hunt Launches',
    tagline: 'Launch execution.',
    description: 'With 11 launches and multiple #1 Product of the Day finishes, I help teams orchestrate Product Hunt launches that hit the top of the leaderboard and convert into real pipeline.',
    outcomes: ['End-to-end launch playbook & timeline', 'Hunter, asset & teaser-page preparation', 'Community & supporter mobilization', 'Strategies engineered to hit #1'],
    featured: false
  }, {
    icon: <Megaphone className="w-6 h-6 text-accent" data-id="element-248" />,
    title: 'Press & Media Features',
    tagline: 'Executive visibility.',
    description: 'As a contributor to TechCrunch, Forbes, and Fortune, I advise founders on securing tier-one media coverage and establishing industry authority.',
    outcomes: ['Targeted journalist outreach strategy', 'Editorial angle development', 'Op-ed drafting and placement', 'Forbes Tech Council & contributor playbook'],
    featured: false
  }];
  return <section id="services" className="py-24 md:py-32" data-id="element-249">
      <div className="container mx-auto px-6 md:px-12" data-id="element-250">
        <SectionReveal data-id="element-251">
          <div className="max-w-2xl mb-16" data-id="element-252">
            <h2 className="font-serif text-4xl md:text-5xl mb-6" data-id="element-253">
              Advisory Services
            </h2>
            <p className="text-lg text-secondary" data-id="element-254">
              Strategic guidance across engineering operations, market
              positioning, and executive visibility.
            </p>
          </div>
        </SectionReveal>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8" data-id="element-255">
          {services.map((service, index) => <SectionReveal key={index} delay={index * 0.08} className={service.featured ? 'md:col-span-2 lg:col-span-1' : ''} data-id="element-256">
              <div className={`h-full p-8 md:p-10 rounded-xl bg-surface border transition-all group ${service.featured ? 'border-accent/40 hover:border-accent shadow-[inset_0_0_20px_rgba(163,230,53,0.06)]' : 'border-border hover:border-accent/40'}`} data-id="element-257">
                <div className="flex items-start justify-between mb-8" data-id="element-258">
                  <div className="w-12 h-12 rounded-lg bg-base border border-border flex items-center justify-center group-hover:border-accent/50 transition-colors" data-id="element-259">
                    {service.icon}
                  </div>
                  <span className="font-mono text-accent text-[10px] uppercase tracking-widest bg-accent/10 px-2 py-1 rounded" data-id="element-260">
                    {service.tagline}
                  </span>
                </div>
                <h3 className="text-2xl font-serif mb-3 tracking-tight" data-id="element-261">
                  {service.title}
                </h3>
                <p className="text-secondary mb-8 leading-relaxed text-sm" data-id="element-262">
                  {service.description}
                </p>
                <div className="pt-6 border-t border-border/50" data-id="element-263">
                  <p className="font-mono text-[10px] text-muted uppercase tracking-widest mb-4" data-id="element-264">
                    Deliverables_
                  </p>
                  <ul className="space-y-3" data-id="element-265">
                    {service.outcomes.map((outcome, i) => <li key={i} className="flex items-start gap-3 text-sm text-secondary" data-id="element-266">
                        <span className="font-mono text-accent text-xs mt-0.5 shrink-0" data-id="element-267">
                          {'>'}
                        </span>
                        {outcome}
                      </li>)}
                  </ul>
                </div>
              </div>
            </SectionReveal>)}
        </div>
      </div>
    </section>;
}